/** Email domain for Validere employees (internal-only UI gates). */
export const INTERNAL_VALIDERE_EMAIL_DOMAIN = "@validere.com";

/**
 * Returns whether an email belongs to an internal Validere user (case-insensitive).
 */
export const isValidereInternalUserEmail = (
  email: string | undefined
): boolean => {
  const normalizedEmail = email?.toLowerCase() ?? "";
  return normalizedEmail.endsWith(INTERNAL_VALIDERE_EMAIL_DOMAIN);
};
